import * as types from "./types";

export const initiateLoading = () => ({
  type: types.IMAGE_LOADING,
});

// canvas
export const storeCanvas = (imageData) => {
  return {
    type: types.STORE_CANVAS,
    payload: imageData,
  };
};

export const clearImageData = () => ({
  type: types.CLEAR_IMAGE_DATA,
});
